import { render } from "./Hypnotherapy.vue?vue&type=template&id=66ec2f09&scoped=true"
import script from "./Hypnotherapy.vue?vue&type=script&lang=js"
export * from "./Hypnotherapy.vue?vue&type=script&lang=js"

import "./Hypnotherapy.vue?vue&type=style&index=0&id=66ec2f09&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66ec2f09"]])

export default __exports__